import React from 'react';
import { Sparkles } from 'lucide-react';

const InitialLoading = () => {
  return (
    <div className="fixed inset-0 bg-white flex flex-col items-center justify-center z-[999]">
      <div className="relative">
        <div className="w-20 h-20 bg-blue-50 rounded-3xl flex items-center justify-center animate-pulse">
          <Sparkles size={40} className="text-blue-500" />
        </div>
        <div className="absolute -inset-4 bg-blue-100 rounded-[40px] -z-10 animate-ping opacity-20" style={{ animationDuration: '2s' }}></div>
      </div>
      
      <div className="mt-8 text-center">
        <h1 className="text-xl font-semibold text-gray-800 tracking-tight">SUMARTS</h1>
        <p className="text-sm text-gray-400 mt-1 font-medium tracking-widest uppercase">夏天艺术工作室</p>
      </div>
      
      <div className="absolute bottom-12 left-0 right-0 flex justify-center">
        <div className="flex gap-1.5">
          <div className="w-1.5 h-1.5 bg-blue-200 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-1.5 h-1.5 bg-blue-300 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-1.5 h-1.5 bg-blue-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
};

export default InitialLoading;
